import { apiClient } from "./apiClient";

export interface UserProfile {
  username: string;
  email: string;
  company?: string;
  accountstatus: number;
  membership: string;
  status: number;
  lastupdate: string;
  bio?: string;
  avatar?: string;
  website?: string;
  badges?: number[];
  restrictions?: number[];
}

export interface ProfileUpdateDto {
  bio?: string;
  avatar?: string;
  website?: string;
  badges?: number[];
}

export const profileAPI = {
  getProfile: async (): Promise<UserProfile> => {
    return await apiClient.get<UserProfile>("/communityprofiles/profile");
  },
  updateProfile: async (data: ProfileUpdateDto): Promise<UserProfile> => {
    return await apiClient.post<UserProfile>("/users/update-profile", data);
  },
};
